import { EventDispatcher, Vector2, Vector3, Plane } from 'three';
import { Utils } from '../core/utils.js';
import { EVENT_MOVED, EVENT_CHANGED,EVENT_DELETED } from '../core/events.js';

export class Label extends EventDispatcher {
    /**
     *  create Icon using icon as data and (x,y) position 
     *  
     * */
    constructor(label, x, y, id) {
        super();

        this.id = id || Utils.guide();

        this.__label = label;
        this.__x = x || 0;
        this.__y = y || 0;

        let textSyle = { fontFamily: 'Arial', fontSize: 18, fill: '#000000', align: 'center', breakWords:true,wordWrap:true,wordWrapWidth:100, padding:0};

        
        this.__name = 'Label';
        this.__text = label.text;
        this.__style = label.style || textSyle;

        

        this.__rotation = label.rotation || 0;
        this.__scale = label.scale || 1;

        this.__location = new Vector2(this.__x,this.__y);

        this.__start = label.start || new Vector2(-50,25);
        this.__end = label.end || new Vector2(50,25);

        this.__start = new Vector2(this.__start.x,this.__start.y)
        this.__end = new Vector2(this.__end.x,this.__end.y)
        
        this.__bounds = null;
        this.__roomData = null;
        this.__corners = [];

        this.__updateDistance();
    }

    __updateDistance(){
        let distance = this.__start.distanceTo(this.__end);
        this.__length = distance;
        // this.__style.wordWrapWidth = this.__length;
        this.dispatchEvent({ type: EVENT_MOVED, item: this });
    }

    __updateRoomData(data){
        this.__roomData = {
            name : data.name,
            factor : data.factor,
            type:data.type,
            color:data.color
        }
    }

    __updateCorners(corners){
        this.__corners = corners;
    }

    set location(vec2){
        this.__location = vec2;
    }

    get location(){
        return this.__location;
    }

    set rotation(deg){
        this.__rotation = deg;
    }

    get rotation(){
        return this.__rotation;
    }


    set scale(vec2){
        this.__scale = vec2;
    }

    get scale(){
        return this.__scale;
    }

    get label(){
        return this.__label;
    }

    get x(){
        return this.__location.x;
    }

    get y(){
        return this.__location.y;
    }

    get name(){
        return this.__name;
    }

    set text(value){
        this.__text = value;
    }

    get text(){
        return this.__text;
    }

    set style(value){
        this.__style = value;
    }

    get style(){
        return this.__style;
    }

    get start(){
        return this.__start;
    }

    set start(value){
            this.__start = value;
            this.__updateDistance();
    }

    get end(){
        return this.__end;
    }

    set end(value){
            this.__end = value;
            this.__updateDistance();
    }

    get length(){
        return this.__length;
    }

    set length(length){
        this.__length = length;
        this.__style.wordWrapWidth = length;
    }
    


    metadata(){
        let json = {};
        json.id = this.id;
        json.name = this.name;
        json.text = this.text;
        json.style = this.style;
        json.location = this.location.toArray();
        json.start = this.start;
        json.end = this.end;
        json.length = this.length;
        json.x = this.x;
        json.y = this.y;
        json.rotation = this.rotation;
        json.scale = this.scale;
        return json;
    }

   

}